export function dateReturn(newDate: { getFullYear: () => any; getMonth: () => any; getDate: () => any; }, period : string){
  switch(period) {
    case 'year':
      return typeof(newDate?.getFullYear()) === 'number' ? newDate?.getFullYear() : new Date().getFullYear();
    case 'month':
      return typeof(newDate?.getMonth()) === 'number' ? newDate?.getMonth() : new Date().getMonth();
    case 'day':
      return typeof(newDate?.getDate()) === 'number' ? newDate?.getDate() : new Date().getDate();                       
    }
}